import { style, media } from 'typestyle'
import { important } from 'csx'
export const pl12mdi = style(media({ maxWidth: 768 }, { paddingLeft: important('12px') }))
